module.exports = __webpack_public_path__ + "media/old_images/image-promo-landing-c293eaee.jpg";